/* ============================================================
   ANIVA — comportements des sections (annonce rotative, sliders
   mobiles, FAQ filtrée, onglets bienfaits, grille ingrédients,
   popups, vidéos UGC lazy, newsletter).
   Custom elements = init idempotente (shopify:section:load ok).
   ============================================================ */
(function () {
  'use strict';

  /* ⚠️ GARDE-FOU D'EXÉCUTION UNIQUE — ne pas retirer.
     Ce fichier est inclus par CHAQUE section aniva-* : la fiche Souplesse en
     porte 5 balises <script src="…aniva-landing.js">. Un navigateur exécute
     chaque balise, même quand l'URL est identique et déjà en cache.
     Les custom elements plus bas étaient déjà protégés par leurs
     `customElements.get(...)`. Les écouteurs posés sur `document`, eux, ne
     l'étaient pas : ils étaient enregistrés cinq fois. Le pire est l'ajout au
     panier `[data-an-add-variant]` — cinq handlers sur le même clic, donc
     cinq lignes envoyées au panier au lieu d'une.
     Mesuré sur la page publiée le 08/08/2026 : 5 balises, 0 garde-fou. */
  if (window.__anivaLanding) return;
  window.__anivaLanding = true;

  if (!customElements.get('aniva-announce')) {
    customElements.define('aniva-announce', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-an-ann-item]'));
        if (this.items.length < 2) return;
        this.i = 0;
        var delay = (parseInt(this.getAttribute('data-delay'), 10) || 5) * 1000;
        this.show(0);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this._t = setInterval(function () {
          this.i = (this.i + 1) % this.items.length;
          this.show(this.i);
        }.bind(this), delay);
      }
      disconnectedCallback() { clearInterval(this._t); }
      show(i) { this.items.forEach(function (el, j) { el.hidden = j !== i; }); }
    });
  }

  if (!customElements.get('aniva-slider-row')) {
    customElements.define('aniva-slider-row', class extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('[data-an-row]');
        this.prev = this.querySelector('[data-an-prev]');
        this.next = this.querySelector('[data-an-next]');
        if (!this.row) return;
        this._upd = this.update.bind(this);
        this.row.addEventListener('scroll', this._upd, { passive: true });
        window.addEventListener('resize', this._upd);
        this._onClick = function (e) {
          var dir = e.target.closest('[data-an-prev]') ? -1 : e.target.closest('[data-an-next]') ? 1 : 0;
          if (!dir) return;
          this.row.scrollBy({ left: dir * (this.row.clientWidth * 0.86 + 14), behavior: 'smooth' });
        }.bind(this);
        this.addEventListener('click', this._onClick);
        setTimeout(this._upd, 300);
        setTimeout(this._upd, 1500);
      }
      disconnectedCallback() {
        if (this.row) this.row.removeEventListener('scroll', this._upd);
        window.removeEventListener('resize', this._upd);
      }
      update() {
        if (!this.prev || !this.next) return;
        var max = this.row.scrollWidth - this.row.clientWidth;
        this.prev.style.display = this.row.scrollLeft > 8 ? 'flex' : 'none';
        this.next.style.display = max - this.row.scrollLeft > 8 ? 'flex' : 'none';
      }
    });
  }

  if (!customElements.get('aniva-faq')) {
    customElements.define('aniva-faq', class extends HTMLElement {
      connectedCallback() {
        this._onClick = function (e) {
          var pill = e.target.closest('[data-an-faq-cat]');
          if (pill) {
            var cat = pill.getAttribute('data-an-faq-cat');
            this.querySelectorAll('[data-an-faq-cat]').forEach(function (p) {
              p.classList.toggle('is-on', p === pill);
            });
            this.querySelectorAll('[data-an-faq-group]').forEach(function (g) {
              g.hidden = g.getAttribute('data-an-faq-group') !== cat;
            });
          }
        }.bind(this);
        this._onToggle = function (e) {
          var det = e.target;
          if (!det.matches || !det.matches('details.an-faq__item') || !det.open) return;
          var group = det.closest('[data-an-faq-group]');
          if (!group) return;
          group.querySelectorAll('details.an-faq__item[open]').forEach(function (d) {
            if (d !== det) d.open = false;
          });
        };
        this.addEventListener('click', this._onClick);
        this.addEventListener('toggle', this._onToggle, true);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('toggle', this._onToggle, true);
      }
    });
  }

  if (!customElements.get('aniva-tabs')) {
    customElements.define('aniva-tabs', class extends HTMLElement {
      connectedCallback() {
        this._onClick = function (e) {
          var tab = e.target.closest('[data-an-tab]');
          if (!tab) return;
          var id = tab.getAttribute('data-an-tab');
          this.querySelectorAll('[data-an-tab]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.querySelectorAll('[data-an-tab-panel]').forEach(function (p) {
            p.hidden = p.getAttribute('data-an-tab-panel') !== id;
          });
        }.bind(this);
        this.addEventListener('click', this._onClick);
      }
      disconnectedCallback() { this.removeEventListener('click', this._onClick); }
    });
  }

  if (!customElements.get('aniva-ingredients')) {
    customElements.define('aniva-ingredients', class extends HTMLElement {
      connectedCallback() {
        this._onClick = function (e) {
          var plus = e.target.closest('[data-an-ing-toggle]');
          if (plus) {
            var card = plus.closest('.an-ing-card');
            var role = card && card.querySelector('[data-an-ing-role]');
            if (!role) return;
            var opening = role.hidden;
            this.querySelectorAll('[data-an-ing-role]').forEach(function (r) { r.hidden = true; });
            this.querySelectorAll('[data-an-ing-toggle]').forEach(function (b) { b.textContent = '+'; b.setAttribute('aria-expanded', 'false'); });
            if (opening) { role.hidden = false; plus.textContent = '−'; plus.setAttribute('aria-expanded', 'true'); }
            return;
          }
          var more = e.target.closest('[data-an-ing-more]');
          if (more) {
            var hiddenCards = this.querySelectorAll('.an-ing-card.an-ing-hide');
            var collapsed = hiddenCards.length > 0;
            this.querySelectorAll('.an-ing-card').forEach(function (c, i) {
              c.classList.toggle('an-ing-hide', !collapsed && i >= 4);
            });
            more.textContent = collapsed ? 'Voir moins' : more.getAttribute('data-label-more');
          }
        }.bind(this);
        this.addEventListener('click', this._onClick);
      }
      disconnectedCallback() { this.removeEventListener('click', this._onClick); }
    });
  }

  /* ---------- Ajout panier générique (cross-sell PDP, grille gamme home) ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-an-add-variant]');
    if (!add) return;
    var id = parseInt(add.getAttribute('data-an-add-variant'), 10);
    if (!id) return;
    add.setAttribute('aria-busy', 'true');
    var done = function () { add.removeAttribute('aria-busy'); };
    if (window.AnivaCart) { window.AnivaCart.add([{ id: id, quantity: 1 }]).then(done, done); }
    else {
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }).then(done, done);
    }
  });

  /* ---------- Popups génériques + lightbox UGC ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-an-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-an-modal-open'));
      if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-an-modal-close]')) {
      var box = e.target.closest('.an-modal,.an-lightbox');
      if (box) {
        box.hidden = true;
        document.body.style.overflow = '';
        var vid = box.querySelector('video');
        if (vid) { vid.pause(); vid.removeAttribute('src'); vid.load(); }
      }
      return;
    }
    var ugc = e.target.closest('[data-an-ugc-open]');
    if (ugc) {
      var lb = document.getElementById('AnivaUgcLightbox');
      if (!lb) return;
      var src = ugc.getAttribute('data-src') || '';
      var poster = ugc.getAttribute('data-poster') || '';
      var vidEl = lb.querySelector('video');
      var ph = lb.querySelector('[data-an-ugc-ph]');
      if (src && vidEl) {
        vidEl.hidden = false; if (ph) ph.hidden = true;
        vidEl.src = src; if (poster) vidEl.poster = poster;
        vidEl.muted = false; vidEl.controls = true;
        lb.hidden = false; document.body.style.overflow = 'hidden';
        vidEl.play().catch(function () {});
      } else {
        if (vidEl) vidEl.hidden = true;
        if (ph) { ph.hidden = false; var nameEl = ph.querySelector('span+span'); if (nameEl) nameEl.textContent = ugc.getAttribute('data-name') || ''; }
        lb.hidden = false; document.body.style.overflow = 'hidden';
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.an-modal:not([hidden]),.an-lightbox:not([hidden])').forEach(function (m) {
      m.hidden = true; document.body.style.overflow = '';
      var vid = m.querySelector('video'); if (vid) vid.pause();
    });
  });

  /* ---------- Vidéos UGC : lecture muette quand visibles (lazy) ---------- */
  var ugcIO = null;
  function bindUgcVideos() {
    if (!('IntersectionObserver' in window)) return;
    if (!ugcIO) {
      ugcIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
            v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: 0.4 });
    }
    document.querySelectorAll('video[data-an-ugc-video]').forEach(function (v) {
      if (v._anBound) return;
      v._anBound = true;
      ugcIO.observe(v);
    });
  }
  bindUgcVideos();
  document.addEventListener('shopify:section:load', bindUgcVideos);

  /* ---------- Newsletter : validation inline (le POST reste natif Shopify) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-an-news-form]') ? e.target : null;
    var wrap = e.target.querySelector ? e.target.querySelector('[data-an-news-form]') : null;
    if (!wrap) return;
    var input = wrap.querySelector('input[type=email]');
    var msg = e.target.parentElement.querySelector('[data-an-news-msg]') || e.target.querySelector('[data-an-news-msg]');
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((input.value || '').trim());
    if (!ok) {
      e.preventDefault();
      if (msg) { msg.textContent = 'Hmm, cet email ne semble pas valide.'; msg.className = 'an-news__msg err'; }
      input.focus();
    }
  });
})();
